import { Validator } from "../validator"

export enum MonthlySalaryError {
    BLANK = `monthly_gross_salary_error`,
}

class MonthlySalaryValidator implements Validator<string, MonthlySalaryError> {
    validate(entry: string): MonthlySalaryError | undefined {
        if (entry === ``) {
            return MonthlySalaryError.BLANK
        }
    }
}

export { MonthlySalaryValidator }